import { AdmintoolMaterialsService, EditMaterialsInfo } from '@admintool/services/admintool-materials.service';
import { IOperation } from '@shared/undo/operation/i-operation';

export class EditArticleMaterialsOperation implements IOperation {

  public constructor(
    private admintoolMaterialsService: AdmintoolMaterialsService,
    private _oldMaterialsInfo: EditMaterialsInfo[],
    private _newMaterialsInfo: EditMaterialsInfo[],
  ) {
  }

  public getQualifiedClassName(): string {
    return 'EditArticleMaterialsOperation';
  }

  public async performRedo(): Promise<void> {
    this.admintoolMaterialsService.applyMaterialChanges(this._newMaterialsInfo);
  }

  public async performUndo(): Promise<void> {
    this.admintoolMaterialsService.applyMaterialChanges(this._oldMaterialsInfo);
  }

  public getOperationDescription(): string {
    return 'editArticleMaterials.operation';
  }
}
